<template>
<div class="profile-board test-editor-burnout">
  <h2 v-if="(loading.results || loading.candidate)">Загрузка...</h2>
  <h2 v-else-if="!res">Тест не завершен</h2>

  <div v-else class="row mt-2 mt-md-8">
    <div class="col-12 col-md-8 pa-3">
      <h3 class="rep-test-title">{{ testData.name }}</h3>

      <div class="test-description">
        <h4 class="desc-title">{{ testData.test_results_title ? testData.test_results_title : '' }} </h4>
        <p v-if="testData.test_results_description" v-html="sanitizeRichHtml(testData.test_results_description)"></p>
      </div>

      <div v-for="(prof, indProf) in positions(testData)" :key="indProf+1000" class="ssp-item">
        <div class="d-flex">
          <Scale10ColorLine :lineData="prof" />
          <!-- <div class="ssp-item-block-legend">{{ prof.interval_aware_value }}</div> -->
          <div class="ssp-item-block-legend">{{ prof.domain ? prof.domain.title : "Без названия" }}</div>
        </div>
      </div>

      <!--
      <hr class="mt-9 mb-6 color-gray" v-if="overall">

      <div class="ssp-item" v-if="overall">
        <div class="d-flex">
          <Scale10ColorLine :lineData="overall" />
          <div class="ssp-item-block-legend">{{ overall.overall_domain ? overall.overall_domain.title : "Без названия" }}</div>
        </div>
      </div>
      -->
      <hr class="mt-9 mb-6 color-gray">

      <!-- <h3 class="rep-test-title">Описание и рекомендации</h3> -->

      <v-expansion-panels v-model="showPanels" multiple>
        <v-expansion-panel v-if="overall" class="accordion" :style="{ '--before-color': getProfColor(overall) }">
          <v-expansion-panel-header>
            <div class="ssp-item-title-accordion triangle-right _bottom-green">
              {{ overall.overall_domain ? overall.overall_domain.title : "Без названия" }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>

            <div class="ssp-item-text" v-html="sanitizeRichHtml(overall.overall_domain ? overall.overall_domain.description : '') " />
            <div class="ssp-item-text" v-html="sanitizeRichHtml(overall.text)" />
            <div class="ssp-item-subtitle triangle-right bottom-green">
              Рекомендации
            </div>
            <template v-if="overall.recommendation">
              <div class="desc-item-text" v-html="sanitizeRichHtml(overall.recommendation)" />
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel class="accordion" v-for="(prof, indProf) in positions(testData)" :key="indProf"
                           :style="{ '--before-color': getProfColor(prof) }"
        >
          <v-expansion-panel-header>
            <div class="ssp-item-title-accordion triangle-right _bottom-green">
              {{ prof.domain ? prof.domain.title : "Без названия" }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="ssp-item-text" v-html="sanitizeRichHtml(prof.domain ? prof.domain.description : '')" />
            <div class="ssp-item-text" v-html="sanitizeRichHtml(prof.text)" />
            <div class="ssp-item-subtitle triangle-right bottom-green">
              Рекомендации
            </div>
            <template v-if="prof.recommendation">
              <div class="desc-item-text" v-html="sanitizeRichHtml(prof.recommendation)" />
            </template>
          </v-expansion-panel-content>
        </v-expansion-panel>

      </v-expansion-panels>
    </div>
  </div>
</div>
</template>

<script>
/* eslint-disable */
import Scale10ColorLine from './Scale10ColorLineBlocksLeadershipStyles.vue';
import { sanitizeRichHtml } from '@/common/util';
import { mapGetters } from 'vuex';

export default {
  components: {
    Scale10ColorLine
  },
  data() {
    return {
      showPanels: 0,
    };
  },
  props: ['testCode'],
  computed: {
    ...mapGetters({
      user: 'auth/user',
      res: 'users/candidate/results',
      loading: 'users/candidate/loading',
      loadingCandidate: 'users/candidate/loading',
    }),
    testData() {
      return this.res?.constructor_test_results && this.res.constructor_test_results[this.testCode]
        ? this.res.constructor_test_results[this.testCode]
        : { name: "Отчет не найден", domains: [] }
    },
    overall() {
      return this.testData.overall_domain_result
    },
  },
  methods: {
    sanitizeRichHtml,
    positions(testData) {
      const arr = [...testData.domains]
      arr.sort((a, b) => b?.value - a?.value)
      return arr
    },
    getProfValue(item) {
      return Math.round(item.value)
    },
    getProfColor(item) {
      const interval = item.intervals.find(el => el.id === item.matched_interval);
      return interval ? interval.color : '#39A9DC'
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/styles/variables";

.test-editor-burnout {

  h3 {
    font-size: 1.6rem;
  }

  .color-gray {
    color: #A2A2A2;
    border-color: #A2A2A2;
  }

  .test-description {
    background: var(--color-bg);
    padding: 20px 10px 10px 20px;
    margin: 20px 0;
    border-radius: 5px;
  }

  .ssp-item-block-legend {
    font-size: 16px;
    font-weight: 600;
    margin: 40px 0 0px 20px;
  }

  .ssp-item-title {
    font-size: 22px;
    font-weight: 600;
    margin: 50px 0 30px 0;
  }
  .ssp-item-title-accordion {
    font-size: 24px;
    font-weight: 600;
    margin: 10px 0 10px 0;

  }


  .ssp-item-subtitle, .ssp-item-text h2 {
    margin: 30px 0 30px 0;
    font-size: 18px;
    font-weight: 600;
  }

  .triangle-right, .ssp-item-text h2{
    display: flex;
    align-items: center;
  }

  .triangle-right::before, .ssp-item-text h2::before {
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 10px solid var(--before-color);
    margin-right: 10px;
    content: '';
  }

  // .item-block-red .triangle-right::before, .item-block-red .ssp-item-text h2::before {
  //   border-left: 10px solid red;
  // }

  .bottom-green, .ssp-item-text h2 {
    position: relative;
  }

  .bottom-green::after, .ssp-item-text h2::after {
    position: absolute;
    bottom: -10px;
    left: 20px;
    width: 120px;
    height: 2px;
    background: var(--before-color);
    opacity: 0.3;
    content: '';
  }

  // .item-block-red .bottom-green::after, .item-block-red .ssp-item-text h2::after {
  //   background: red;
  // }

  @media screen and (max-width: 600px) {
    .ssp-item-block-legend {
      margin: 35px 0 0px 10px;
      font-size: 12px;
    }
  }


}
</style>
